// eslint-disable-next-line no-restricted-imports, @fl/relative-imports-in-index-files-only
import * as Antd from 'antd';

/** Central Ant Design namespace used by the app so imports stay consistent. */
export const Ant = Antd;
/** Shared Ant Design layout wrapper used by the shell and page content containers. */
export const AntLayout = Antd.Layout;
